/**
 * @format
 */

import { AppRegistry, Platform } from 'react-native';
import App from './App';
import { name as appName } from './app.json';

// Регистрация компонента
AppRegistry.registerComponent(appName, () => App);

// Отключение логов в проде
if (!__DEV__) {
    console.log = () => {};
    console.warn = () => {};
    console.error = () => {};
}

// Запуск web-приложения
if (Platform.OS === 'web') {
    AppRegistry.runApplication(appName, {
        initialProps: {},
        rootTag: document.getElementById('app'),
    });
}
